export default __webpack_public_path__ + "static/media/CNo.82-5.48684c9f.jpg";